import { Alert, AlertTitle, Divider } from '@mui/material'

import { MAX_LOADS_FOR_ORDER } from '@/constants'

import { FormData } from '../../../types'

import { BulkLoads } from '../../primitives/BulkLoads'

import { form } from '../../../formState'

import { createValidateLoads } from './hooks/createValidateLoads'
import { useFieldStatus } from './hooks/useFieldStatus'
import { useTexts } from './hooks/useTexts'

interface Props {
  orders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function Loads(props: Props) {
  const texts = useTexts()
  const status = useFieldStatus(props.orders)

  form.useAddFieldValidation('loads', (field, _formApi) => {
    const loadsField = field.value
    if (loadsField) {
      const loadsValidationMessage = createValidateLoads(texts, loadsField)
      return loadsValidationMessage
    }
  })

  if (status === 'all-service') return null

  return (
    <form.Fieldset>
      <BulkLoads<'loads', FormData>
        name="loads"
        label={texts.loads}
        addLoadLabel={texts.addLoad}
        maxLoadsForOrder={MAX_LOADS_FOR_ORDER}
        disabled={status === 'at-least-one-service'}
        testId="loads"
      />
      {status === 'at-least-one-service' && (
        <Alert severity="warning">
          <AlertTitle>{texts.waringCardTitle}</AlertTitle>
          {texts.waringCardText}
        </Alert>
      )}
      <Divider />
    </form.Fieldset>
  )
}
